import * as model from "@/model/prd/productionExecution/smelting/SlagIronPara";
import { newEntityStoreHelper } from "@/store/common/entityModule";
import router from "@/router";
import _ from 'lodash';


function newFilter(paginationFilter = {}) {
  var filter = Object.assign({}, paginationFilter, model.filter)
  // console.log(filter)
  return filter;
}

const baseStore = newEntityStoreHelper(() => new model.SlagIronPara(), newFilter).buildStore();

function date2str(date) {
  let year = date.getFullYear();
  let month = date.getMonth();
  let d = date.getDate();
  return `${year}-${month + 1}-${d}`;
}

const baseUrl = process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd";

const slagIronParaStore = {
  namespaced: true,
  state: {
    baseModuleUrl: baseUrl,
    currentSlagIronPara: {},
  },
  mutations: {
    setCurrentSlagIronPara(state, data) {
      state.currentSlagIronPara = data;
    },
  },
  actions: {
    jumpToEdit(context, item) {
      context.commit("slagIronPara/setCurrentSlagIronPara", item, {
        root: true
      });
      router.push({
        name: "slagIronParaEdit"
      });
    },
    findAll(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/slagIronPara/findAll',
      }, {
          root: true,
        });
    },
    findPage(context, { index, size }) {
      const data = new FormData();
      data.append('page', index)
      data.append('size', size)

      return context.dispatch('api/post', {
        url: baseUrl + '/slagIronPara/findPage',
        data,
      }, {
          root: true,
        });
    },
    deleteById(context, id) {
      const data = new FormData();
      data.append('id', id)
      return context.dispatch('api/post', {
        url: baseUrl + '/slagIronPara/delete',
        data,
      }, {
          root: true,
        });
    },
    getLength(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/slagIronPara/getLength',
      }, { root: true })
    },
    saveCurrentSlagIronPara(context) {
      return context.dispatch('saveSlagIronPara', context.state.currentSlagIronPara);
    },
    saveSlagIronPara(context, slagIronPara) {
      let data = new FormData();
      let id = slagIronPara.id > 0 ? slagIronPara.id : -1;
      data.append('id', id);
      data.append('date', date2str(slagIronPara.date));
      data.append('locName', slagIronPara.locName);
      data.append('locId', slagIronPara.locId);
      data.append('furnaceNumber', slagIronPara.furnaceNumber);
      data.append('furnaceTime', slagIronPara.furnaceTime);
      data.append('drillNumber', slagIronPara.drillNumber);
      data.append('startTime', slagIronPara.startTime);
      data.append('endTime', slagIronPara.endTime);
      data.append('packNumber1', slagIronPara.packNumber1);
      data.append('packNumber2', slagIronPara.packNumber2);
      data.append('emptyPack1', slagIronPara.emptyPack1);
      data.append('emptyPack2', slagIronPara.emptyPack2);
      data.append('slag1', slagIronPara.slag1);
      data.append('slag2', slagIronPara.slag2);
      data.append('pouring1', slagIronPara.pouring1);
      data.append('pouring2', slagIronPara.pouring2);
      data.append('outletIron', slagIronPara.outletIron);
      data.append('outletSlag',slagIronPara.outletSlag);
      data.append('energyCost',slagIronPara.energyCost);
      return context.dispatch('api/post', {
        url: baseUrl + '/slagIronPara/save',
        data,
      }, {
          root: true,
        })
    }
  }
}

export default _.defaultsDeep(slagIronParaStore, baseStore); // 合并 teamShiftStore 和 baseStore (冲突时选前者)